import { createContext } from 'react';

const Mozhi = createContext({});

export default Mozhi;
